// extracted by mini-css-extract-plugin
export default {"ValueSetTable":"v80inUU_hqP9o4gp7Fab","value":"T2jS67UEXYfbM9sKUf5F"};